import React from "react";
import Loader from 'react-loader-spinner'
import HttpService from '../../utils/Http.services';
import { checkTranslation } from "../../utils/useful";

class LocalSelectInput extends React.Component {
    state = {
        options: [],
        isLoading: false
    }

    componentDidMount() {
        // console.log(this.props.data)
        this.init(true)
    }


    componentDidUpdate(prevProps) {

        // console.log(this.props.data)

        if (this.state.options != this.props.header.information.items) {
            this.setState({ options: this.props.header.information.items })
        }
    }

    init(mount) {

        // console.log(this.props.data)

        // if(!mount){
        //     this.props.changeValue(this.props.header.key, null, this.props.extra) 
        // }
        if (this.props.header.information) {
            this.setState({ options: this.props.header.information.items })
        }

    }




    spliter(source, string) {
        var stringArray = string.split('.')
        var finalString = source
        stringArray.forEach(element => {
            if (finalString) {
                finalString = finalString[element]
            }
        });
        return finalString
    }


    conditionalSettings(param, condition) {
        if (this.props.settings) {
            if (this.props.settings[param] === condition) {
                return true
            }
        }
        return false
    }


    changeValue = (e) => {
        console.log(e.target.value)
        this.props.changeValue(this.props.header.key, e.target.value, this.props.extra)
    }


    render() {
        let dataValue = ''
        if (this.props.data) {
            dataValue = typeof this.props.data == "object" ? (this.props.data._id ?? this.props.data.id) : this.props.data
        }

        // console.log( this.state.options)
        // console.log(this.props.header.information)
        return (
            <div className='w-100' style={{ position: 'relative' }}>
                <div style={{ position: 'relative' }}>
                    <select value={dataValue} disabled={this.conditionalSettings('disabled', true)} onChange={e => { this.changeValue(e) }} className=' ' style={{ WebkitAppearance: 'none', border: 'none', boxShadow: 'none', backgroundColor: 'transparent', color: '#3b3a40', width: '100%', padding: 0, outline: 'none' }}>
                        <option disabled={this.props.header.information.required ? true : false} hidden={this.props.header.information.required ? true : false} value="">{checkTranslation(this.props.header.information.placeholder) ?? 'Select ...'}</option>
                        {Array.isArray(this.state.options) && this.state.options?.map((prop, index) => {
                            let titleName = Object.keys(prop)?.filter(i => i.includes('textTitle'))?.at(0)

                            return (
                                <option key={index} value={checkTranslation(prop.id)}>{checkTranslation(prop[titleName])}</option>
                            )
                        })}
                    </select>
                    {this.conditionalSettings('showInfo', true) && (

                        <p onClick={() => { if (!this.state.isLoading) { this.props.showInfo(this.props.header.information.filter, this.props.data, this.props.settings.url, this.props.settings.page) } }} style={{ fontSize: 13, color: this.state.isLoading ? '#789' : '#007aff', marginTop: 3, cursor: 'pointer', marginLeft: 3 }}>Show information</p>
                    )}

                    {this.state.isLoading && (
                        <div style={{ position: 'absolute', top: -2, right: 0 }}>
                            <Loader
                                type="ThreeDots"
                                color="#9ab"
                                height="25"
                                width="25"
                            />
                        </div>
                    )}

                </div>

            </div>
        );
    }
}

export default LocalSelectInput;
